
document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.custom-collection-swiper', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      '@0': {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      '@0.75': {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      '@1.00': {
        slidesPerView: 3,
        spaceBetween: 20,
      }
    }
  });
})
